export class TerminModel {
    // Vertragnepraunik
    Id: string;
    Subject: string;
    Terminstatus: string;
    StartDateString: string;
    EndDateString: string;
}


// WEBPACK FOOTER //
// ./src/app/schemas/TerminModel.ts